module.exports = __webpack_public_path__ + "media/safari/share-cb9c7497.png";